import {DateTime} from "luxon";

export enum AttributeType {
  BOOLEAN = 'boolean',
  DATE = 'date',
  SELECT = 'select',
  STRING = 'string',
}

type BaseAttribute = {
  id: number
  uuid: string
  type: AttributeType,
  name: string
  slug: string
  label: string
  created_at: DateTime
  updated_at: DateTime
}

export type BooleanAttribute = BaseAttribute & {
  type: AttributeType.BOOLEAN,
  rules: {}
}

export type DateAttribute = BaseAttribute & {
  type: AttributeType.DATE,
  rules: {
    min?: string,
    max?: string,
  }
}

export type SelectAttribute = BaseAttribute & {
  type: AttributeType.SELECT,
  rules: {
    options: Array<string>
  }
}

export type StringAttribute = BaseAttribute & {
  type: AttributeType.STRING,
  rules: {
    min?: string,
    max?: string,
  }
}

export type Attribute = BooleanAttribute | DateAttribute | SelectAttribute | StringAttribute

export type AttributeData = {
  uuid?: string | null,
  type: AttributeType,
  name: string,
  label: string,
  rules: {
    [key: string]: string
  } | null
}